import groq from 'groq';

export const VIBE_GALLERY = groq`
  galleryName
`;

export const VIBE_GALLERY_BLOCK = groq`
  _type == 'timeline_vibeGallery' => {
    ${VIBE_GALLERY}
  }
`;
